(function($) {
  $.ajaxPost = function( query ) {
    return $.ajax( {
      url: '/wp-json/wp/v2/posts',
      data: query,
      dataType : 'json'
    });
  };

})(jQuery);
